import { Slide } from "@jelly/lesson";
import theory from "../../theory";
import config from "appConfig";

const principle: Slide = {
  description:
    "A method for estimating the Thiele and Small parameters of an electrodynamic loudspeaker is presented below. Navigate with the arrows to discover it!",
  theory: theory,
  layout: {
    type: "table",
    options: {
      cols: 1,
      rows: 4,
      rowsSize: [1, 0.5, 3, 0.5],
      gap: "2%",
      components: [
        [
          {
            variant: "blockContainer",
            data: {
              block: {
                type: "text",
                options: {
                  data: "measured impedance of the driver in a baffle",
                  scrollbars: false,
                  formatter: "html",
                  styles: {
                    fontSize: "14px",
                    lineHeight: "22px",
                    fontWeight: 800,
                    letterSpacing: "0.25em",
                    textTransform: "uppercase",
                  },
                },
              },
            },
          },
        ],
        [
          {
            variant: "blockContainer",
            data: {
              block: {
                type: "text",
                options: {
                  data: "3 curves are drawn to show repeatibility",
                  scrollbars: false,
                  formatter: "html",
                  styles: {
                    fontSize: "14px",
                    lineHeight: "20px",
                    fontWeight: 400,
                  },
                },
              },
              styles: {
                alignItems: "flex-end",
                textAlign: "center",
              },
            },
          },
        ],
        [
          {
            variant: "blockContainer",
            data: {
              block: {
                type: "image",
                options: {
                  src: `${config.ASSETS_URL}/04/19/principle/slide-3.svg`,
                },
              },
            },
          },
        ],
        [
          {
            variant: "blockContainer",
            data: {
              block: {
                type: "text",
                options: {
                  data:
                    "f<sub>1</sub> and f<sub>2</sub> are obtained for Z<sub>et</sub>(f<sub>1</sub>, f<sub>2</sub>) = <math display=inline xmlns=http://www.w3.org/1998/Math/MathML> <msqrt> <msub> <mrow> <mi>Z</mi> </mrow> <mrow> <mi>et</mi> </mrow> </msub> <mo>(</mo> <msub> <mrow> <mi>f</mi> </mrow> <mrow> <mi>s</mi> </mrow> </msub><mo>)</mo> <msub> <mrow> <mi>R</mi> </mrow> <mrow> <mi>e</mi> </mrow> </msub> </msqrt> <mo>=</mo> <msqrt> <mn>60.5</mn><mo>x</mo><mn>3.85</mn></msqrt> <mo>=</mo> <mn>15.26</mn> <mi>Ω</mi></math>",
                  scrollbars: false,
                  formatter: "html",
                  styles: {
                    fontSize: "14px",
                    lineHeight: "20px",
                    fontWeight: 400,
                  },
                },
              },
              styles: {
                alignItems: "flex-start",
              },
            },
          },
        ],
      ],
    },
  },
};

export default principle;
